import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["select"]

  load(event) {
    const employeeId = event.target.value
    if (!employeeId) {
      this.hideForm()
      return
    }

    fetch(`/employees/${employeeId}/edit_working_hours`, {
      headers: { Accept: "text/vnd.turbo-stream.html" },
    })
      .then((res) => res.text())
      .then((html) => Turbo.renderStreamMessage(html))
      .catch((error) => {
        console.error("Error loading working hours:", error)
      })
  }

  hideForm() {
    const frame = document.getElementById("employee_working_hours")
    if (frame) {
      frame.innerHTML = ""
    }
  }

  toggleHoursContainer(event) {
    const employeeId = event.target.value
    const container = document.getElementById("employee_working_hours")

    if (!employeeId && container) {
      container.innerHTML = ""
    }
  }
}
